import React, { ChangeEvent, useMemo } from 'react';
import { useMessages } from '@hooks/useMessages';
import { FormGroup, Label } from 'reactstrap';
import { PasswordHelper } from './PasswordHelper';
import { PasswordInput } from '@src/components/organisms/password/PasswordInput';

interface Props {
  password: string;
  confirmPassword: string;
  setPassword: (password: string) => void;
  setConfirmPassword: (password: string) => void;
  showLabels?: boolean;
}

export const CreatePasswordFormGroup: React.FC<Props> = ({
  password,
  confirmPassword,
  setPassword,
  setConfirmPassword,
  showLabels = false,
}) => {
  const { messages } = useMessages();

  const isConfirmPasswordValid = useMemo(
    () => !confirmPassword || confirmPassword === password,
    [confirmPassword, password]
  );

  return (
    <>
      <FormGroup>
        {showLabels && (
          <Label for="new-password">{messages('new_password_label')}</Label>
        )}
        <PasswordInput
          id="new-password"
          placeholder={showLabels ? undefined : messages('new_password_label')}
          value={password}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setPassword(e.target.value)
          }
          autoComplete="new-password"
        />
        <PasswordHelper password={password} />
      </FormGroup>
      <FormGroup>
        {showLabels && (
          <Label for="confirm-password">
            {messages('confirm_password_label')}
          </Label>
        )}
        <PasswordInput
          id="confirm-password"
          placeholder={
            showLabels ? undefined : messages('confirm_password_label')
          }
          value={confirmPassword}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setConfirmPassword(e.target.value)
          }
          invalid={!isConfirmPasswordValid}
          invalidMessage={messages('passwords_do_not_match')}
          autoComplete="new-password"
        />
      </FormGroup>
    </>
  );
};
